export const EMAIL_MAX_LENGTH = 64
export const USERNAME_MIN_LENGTH = 6
export const USERNAME_MAX_LENGTH = 36
export const PASSWORD_MIN_LENGTH = 8
export const PASSWORD_MAX_LENGTH = 50
export const USER_MIN_DATE_OF_BIRTH = '1900-01-01'

export const ACTIVITY_LIST_MAX_ITEMS = 25
